import { render, staticRenderFns } from "./statusDropdown.vue?vue&type=template&id=97f90c80&"
import script from "./statusDropdown.vue?vue&type=script&lang=js&"
export * from "./statusDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97f90c80')) {
      api.createRecord('97f90c80', component.options)
    } else {
      api.reload('97f90c80', component.options)
    }
    module.hot.accept("./statusDropdown.vue?vue&type=template&id=97f90c80&", function () {
      api.rerender('97f90c80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/appointments/components/statusDropdown.vue"
export default component.exports